import { Cookies } from 'react-cookie';

import { isServiceProviderExistsResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getIsServicePorviderExists = async () => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get('is_pest_company_created/', {
    headers: {
      Authorization: token,
    },
  });

  return data.data as isServiceProviderExistsResponse;
};
